import React from 'react';
import './App.scss';
import InfoModal from './InfoModal';

const { useState, useCallback } = React;

const INSULTS = {
  de: {
    adjectiveMale: [
      "dämlicher", "blöder", "hirnloser", "tölpelhafter", "schwachsinniger",
      "unfähiger", "lächerlicher", "idiotischer", "verrückter", "absurder",
      "peinlicher", "läppischer", "hirnrissiger", "schräger", "verrückter",
      "dusseliger", "trotteliger", "blödsinniger", "schräger", "verrückter",
      "armseliger", "jämmerlicher", "rechtsextremer", "verwirrter",
      "knochenloser", "schwacher", "feiger", "hinterhältiger", "verlogener", "hirnverbrannter"
    ],
    adjectiveFemale: [
      "dämliche", "blöde", "hirnlose", "tölpelhafte", "schwachsinnige",
      "unfähige", "lächerliche", "idiotische", "verrückte", "absurde",
      "peinliche", "läppische", "hirnrissige", "schräge", "verrückte",
      "dusselige", "trottelige", "blödsinnige", "schräge", "verrückte",
      "armselige", "jämmerliche", "rechtsextreme", "verwirrte",
      "knochenlose", "schwache", "feige", "hinterhältige", "verlogene", "hirnverbrannte"
    ],
    adjectiveNeutral: [
      "dämliches", "blödes", "hirnloses", "tölpelhaftes", "schwachsinniges",
      "unfähiges", "lächerliches", "idiotisches", "verrücktes", "absurdes",
      "peinliches", "läppisches", "hirnrissiges", "schräges", "verrücktes",
      "dusseliges", "trotteliges", "blödsinniges", "schräges", "verrücktes",
      "armseliges", "jämmerliches", "rechtsextremes", "verwirrtes",
      "knochenloses", "schwaches", "feiges", "hinterhältiges", "verlogenes", "hirnverbranntes", 
    ],
    nounMale: [
      "Vollpfosten", "Trottel", "Depp",
      "Hornochse", "Quälgeist", "Blödmann",
      "Armleuchter", "Doofkopp", "Schlappschwanz", "Waschlappen",
      "Vollidiot", "Rüpel", "Stinkstiefel", "Pantoffelheld",
      "Warmduscher", "Schleimscheißer", "Wichtigtuer", "Haarspalter", "Klugscheißer",
      "Schreihals", "Drecksack", "Schwachkopf", "Lappen", "Hirni",
      "Schwachmat", "Feigling", "Hinterhältling", "Lügner", "Verräter", "nudeldrucker", "eierbär", "arschkriecher", "wurmfortsatz", 
      "wappler", "fpöler", "fascho", "rassist", "sexist", "misogynist", "homophobiker", "islamophobiker", "xenophobiker", "trumpist",
      "gschichteldrucker", "affenarsch", "wurstl", "hirnfurz", "hirnwichser", "hirnschiss", "hirnverbrannter", "patridiot", "affe", "petromaskulinist", 
      "kasperl"
    ],
    nounFemale: [
      "Hohlbirne", "Dumpfbacke",
      "Flachzange", "Schlafmütze", "Niete",
      "Pfeife", "Flasche", "Heulsuse", 
      "Knalltüte", "Luftnummer",
      "Meckerziege", "Drecksau", "gschichteldruckerin", "eierbärin", "arschkriecherin", "wurmfortsatzin",
      "wapplerin", "fpölerin", "faschistin", "rassistin", "sexistin", "misogynistin", "homophobikerin", "islamophobikerin", "xenophobikerin", "trumpistin",
      "arschgeige", "hirnverbrannte","patridiotin",
    ],
    nounNeutral: [
      "Weichei", "Schwammerl", "Gewürm", "Gedärm", "nudelaug", "nazischwein", "rassistenschwein", "sexistenschwein", "misogynistenschwein", "homophobikerschwein", "islamophobikerschwein", "xenophobikerschwein",
    ]
  },
  en: {
    adjective: [
      "dumb", "stupid", "idiotic", "silly", "foolish",
      "ridiculous", "absurd", "nonsensical", "preposterous", "outlandish",
      "ludicrous", "laughable", "pathetic", "ridiculous", "absurd",
      "foolish", "silly", "nonsensical", "preposterous", "outlandish",
      "ludicrous", "laughable", "pathetic", "ridiculous", "absurd",
      "foolish", "silly", "nonsensical", "preposterous", "outlandish",
      "cowardly", "spineless", "gutless", "weak", "feeble",
      "lame", "pathetic", "pitiful", "wimpy", "scrawny",
    ],
    noun: [
      "Muppet", "Numpty", "Dingbat", "Knucklehead", "Doofus",
      "Dimwit", "Buffoon", "Nincompoop", "Twit", "Clod",
      "Nitwit", "Dunce", "Blockhead", "Bozo", "Clodhopper",
      "Noodlebrain", "Halfwit", "Lamebrain", "Airhead", "Dunderhead",
      "Muppet", "Plonker", "Pillock", "Numskull",
      "Nutter", "Tosser", "Muppethead", "maggot", "worm", "vermin",
      "loser", "wimp", "coward", "traitor", "scoundrel", "villain",
      "jerk", "idiot", "fool", "moron", "imbecile", "cretin", "asshole",
      "bastard", "dickhead", "prick", "douchebag", "asshat", "dickweed", "shithead", "fuckwit", "wankstain", "tosspot", "arsehole", "bollocks",
      "trumpist", "trumpanzee", "trumpster", "trumptard", "trumplethinskin", "trumplestiltskin", "trumplethinskin", 
      "fascist", "nazi", "racist", "sexist", "misogynist", "homophobe", "islamophobe", "xenophobe"
    ]
  }
};
const PRAISES = {
  de: {
    adjectiveMale: [
      "toller", "großartiger", "fantastischer", "hervorragender", "ausgezeichneter",
      "brillanter", "genialer", "sensationeller", "überragender", "exzellenter",
      "fabelhafter", "wunderbarer", "grandioser", "spektakulärer", "phänomenaler", "bewundernswerter", "großzügiger", "herzlicher", "liebevoller", "treuer", "loyaler", "zuverlässiger", "verständnisvoller", "hilfsbereiter", "freundlicher", "sympathischer", "charmanter", "attraktiver", "intelligenter", "witziger", "charismatischer", "mutiger", "starker", "ehrlicher", "respektvoller", "toleranter", "offener", "kreativer", "inspirierender", "leidenschaftlicher", "engagierter", "zielstrebiger", "erfolgreicher",
    ],
    adjectiveFemale: [
      "tolle", "großartige", "fantastische", "hervorragende", "ausgezeichnete",
      "brillante", "geniale", "sensationelle", "überragende", "exzellente",
      "fabelhafte", "wunderbare", "grandiose", "spektakuläre", "phänomenale", "bewundernswerte", "großzügige", "herzliche", "liebevolle", "treue", "loyale", "zuverlässige", "verständnisvolle", "hilfsbereite", "freundliche", "sympathische", "charmante", "attraktive", "intelligente", "witzige", "charismatische", "mutige", "starke", "ehrliche", "respektvolle", "tolerante", "offene", "kreative", "inspirierende", "leidenschaftliche", "engagierte", "zielstrebige", "erfolgreiche",
    ],
    adjectiveNeutral: [
      "tolles", "großartiges", "fantastisches", "hervorragendes", "ausgezeichnetes",
      "brillantes", "geniales", "sensationelles", "überragendes", "exzellentes",
      "fabelhaftes", "wunderbares", "grandioses", "spektakuläres", "phänomenales", "bewundernswertes", "großzügiges", "herzliches", "liebevolles", "treues", "loyales", "zuverlässiges", "verständnisvolles", "hilfsbereites", "freundliches", "sympathisches", "charmantes", "attraktives", "intelligentes", "witziges", "charismatisches", "mutiges", "starkes", "ehrliches", "respektvolles", "tolerantes", "offenes", "kreatives", "inspirierendes", "leidenschaftliches", "engagiertes", "zielstrebiges", "erfolgreiches",
    ],
    nounMale: [
      "Held", "Champion", "Sieger", "Gewinner",
      "Meister", "König", "Gott", "Heiliger",
      "Sonnenschein", "Liebling", "Schatz",
    ],
    nounFemale: [
      "Heldin", "Siegerin", "Gewinnerin", "Heilige",
      "Meisterin", "Königin", "Göttin", "Göttlichkeit", "Meisterschaft",
    ],
    nounNeutral: [
      "Genie", 
    ]
  },
  en: {
    adjective: [
      "wonderful", "fantastic", "amazing", "incredible", "marvelous",
      "brilliant", "genius", "sensational", "outstanding", "excellent",
      "fabulous", "wondrous", "grandiose", "spectacular", "phenomenal",
    ],
    noun: [
      "genius", "hero", "champion", "saint", "winner",
      "master", "king", "god", "queen", "goddess",
      "sunshine", "darling", "treasure",
    ]
  }
};

function speak(text, lang) {
  if (!window.speechSynthesis) {
    return;
  }
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = lang === 'de' ? 'de-DE' : 'en-GB';
  u.rate = 0.9;
  u.pitch = 0.85;
  window.speechSynthesis.speak(u);
}

function App() {
  // select language based on browser settings
  const browserLang = navigator.language || navigator.userLanguage;
  const defaultLang = browserLang.startsWith('de') ? 'de' : 'en';
  const [lang, setLang] = useState(defaultLang);
  const [line, setLine] = useState(null);
  const [showInfo, setShowInfo] = useState(false);

  const generate = useCallback((l, type) => {
    const generateGerman = (type) => {
      const data = type === 'insult' ? INSULTS.de : PRAISES.de;
      const nouns = [...data.nounMale, ...data.nounFemale, ...data.nounNeutral];
      let noun;
      let adjective;
      let chosen;
      do {
        noun = nouns[Math.floor(Math.random() * nouns.length)];
        chosen = adjective + " " + noun;
      }
      while (chosen === line && nouns.length > 1);

      // Adjektiv entsprechend des Geschlechts des Substantivs auswählen
      if (data.nounMale.includes(noun)) {
        adjective = data.adjectiveMale[Math.floor(Math.random() * data.adjectiveMale.length)];
      }
      else if (data.nounFemale.includes(noun)) {
        adjective = data.adjectiveFemale[Math.floor(Math.random() * data.adjectiveFemale.length)];
      }
      else {
        adjective = data.adjectiveNeutral[Math.floor(Math.random() * data.adjectiveNeutral.length)];
      }

      chosen = "du " + adjective.toLowerCase() + " " + noun.toLowerCase() + "!";

      setLine(chosen);
      speak(chosen, 'de');
    }

    const generateEnglish = (type) => {
      const data = type === 'insult' ? INSULTS.en : PRAISES.en;
      const adjectives = [...data.adjective];
      const nouns = [...data.noun];
      let noun;
      let adjective;
      let chosen;
      do {
        adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
        noun = nouns[Math.floor(Math.random() * nouns.length)];
        chosen = adjective + " " + noun;
      }
      while (chosen === line && adjectives.length > 1 && nouns.length > 1);

      chosen = chosen.toLowerCase() + "!";
      setLine(chosen);
      speak(chosen, 'en');
    }

    if (lang === 'de') {
      generateGerman(type);
    }
    else {
      generateEnglish(type);
    }
  });

  const info = useCallback(() => {
    setShowInfo(true);
  });

  return (
    <div className="App">
      <div id="app">
        <div id="lang-toggle">
          <button className={lang === 'en' ? "btn active" : "btn"} onClick={() => {setLang('en'); setLine(null);}}>en</button>
          <button className={lang === 'de' ? "btn active" : "btn"} onClick={() => {setLang('de'); setLine(null);}}>de</button>
        </div>
        <div id="info">
          <button className="btn active" onClick={info}>info</button>
        </div>
        
        <div className="insult-legend">
          {lang === 'de' ? 'beschimpfung' : 'insult'}
        </div>
        <div className="praise-legend">
          {lang === 'de' ? 'lob' : 'praise'}
        </div>

        <div className="insult-box" onClick={(e) => {generate(lang, e.clientX <  window.innerWidth / 2 ? 'insult' : 'praise');}}>
          <div className="insult-text">
            {line || (lang === 'de' ? 'klick irgendwo!' : 'click somewhere!')}
          </div>
        </div>
      </div>
      <InfoModal isOpen={showInfo} onClose={() => setShowInfo(false)} lang={lang} />
    </div>
  );
}

export default App;
